import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import {
  ConditionalRenderer,
  useLanguageTranslator,
  Header,
} from "../../components";
import { SubmissionsTab } from "./submissionsTab";
import { CompositeIndex } from "./compositeIndex";

function Dashboard() {
  const { translator } = useLanguageTranslator();
  const location = useLocation();
  const isStudent = location?.pathname?.includes("/submission/dashboard");

  return (
    <Box pb={4}>
      <Header
        title={translator("My Custom Indicators")}
        subtitle=""
        isSearchField={false}
      />
      <ConditionalRenderer condition={!isStudent}>
        {/*Begin composite index chart */}
        <CompositeIndex />
        {/* end composite index chart */}

        {/* BEGIN: List of policies */}
        {/* <Container sx={{ my: 3 }}>
          <Paper component={Container} sx={{ py: 3, mb: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h4">{translator("Policies")}</Typography>
              </div>
              <Link href="/policies/all" underline="none" color="textSecondary">
                {translator("View all")}
              </Link>
            </Stack>
          </Paper>
          <Paper component={Container} sx={{ py: 3, mb: 2 }}>
            <Typography variant="h4" ml={3}>
              {translator("Last Policies")}
            </Typography>
          </Paper>

          <Grid container spacing={2}>
            {policies?.map((elem: any, i: any) => (
              <Grid key={`${i}`} item xs={12} md={6} lg={3}>
                <Card
                  status={elem?.status}
                  path={`/policies/${elem?.id}`}
                  title={elem?.title}
                  description={elem?.description}
                  createdAt={elem?.createdAt}
                />
              </Grid>
            ))}
          </Grid>
        </Container>

        <LatestReport
          items={policyDocuments}
          loading={policiesDocLoading}
          path="/policies/view-all-Reports"
          subtitle={translator("Last Policies Documents")}
          isDashboard={true}
        /> */}
        {/* END: List of policies */}

        {/* BEGIN: List of practices */}
        {/* <Container sx={{ my: 3 }}>
          <Paper component={Container} sx={{ py: 3, mb: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h4">{translator("Practices")}</Typography>
              </div>
              <Link
                href="/practices/all"
                underline="none"
                color="textSecondary"
              >
                {translator("View all")}
              </Link>
            </Stack>
          </Paper>

          <Paper component={Container} sx={{ py: 3, mb: 2 }}>
            <Typography variant="h4" ml={3}>
              {" "}
              {translator("Last Practices")}
            </Typography>
          </Paper>

          <Grid container spacing={2}>
            {practices?.map((elem: any, i: number) => (
              <Grid key={`${i}`} item xs={12} md={6} lg={3}>
                <Card
                  status={elem?.status}
                  path={`/practices/${elem?.id}`}
                  title={elem?.title}
                  description={elem?.description as any}
                  createdAt={elem?.createdAt}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
        <LatestReport
          items={practiceDocuments}
          path="/practices/view-all-Reports"
          subtitle={translator("Last Practices Documents")}
        /> */}
        {/* END: List of practices */}

        {/* BEGIN: List of people */}
        {/* <Container sx={{ my: 3 }}>
          <Paper component={Container} sx={{ py: 3, mb: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="h4">{`${translator(
                  "List of"
                )} ${translator("People")}`}</Typography>
              </div>
              <Link href="/people/all" underline="none" color="textSecondary">
                {translator("View all")}
              </Link>
            </Stack>
          </Paper>
          <Paper component={Container} sx={{ py: 3, mb: 2 }}>
            <Typography variant="h4" ml={3}>
              {translator("Last People")}
            </Typography>
          </Paper>

          <Grid container spacing={2}>
            {data?.people?.collection?.map((elem: any, i: any) => (
              <Grid key={`dashboard-peoples-${i}`} item xs={12} md={6} lg={3}>
                <PersonCard person={elem} />
              </Grid>
            ))}
          </Grid>
        </Container> */}
        {/* END: List of people */}
      </ConditionalRenderer>

      <ConditionalRenderer condition={!!isStudent}>
        {/* BEGIN: Submissions data */}
        <SubmissionsTab />
        {/* END: Submissions data */}
      </ConditionalRenderer>
    </Box>
  );
}

export { Dashboard };
